import { Alert } from '@mui/material'
import { FC } from 'react'
import { useRecordContext, useTranslate } from 'react-admin'
import { CertificateOut } from '../../types/apiRequests'


const ExpiryAlert: FC = () => {
  const record = useRecordContext<CertificateOut>()
  const translate = useTranslate()
  if (!record?.verloopDatum) return null

  const now = new Date()
  const expiry = new Date(record.verloopDatum)
  const msPerDay = 1000 * 60 * 60 * 24
  const daysUntil = Math.ceil((expiry.getTime() - now.getTime()) / msPerDay)

  const dateStr = expiry.toLocaleString(undefined, {
    dateStyle: 'long',
    timeStyle: 'short',
  })

  if (daysUntil < 0) {
    return (
      <Alert severity="error" sx={{ mb: 2 }}>
        {translate('resources.certificates.alerts.expired', {
          date: dateStr,
          _: `Certificaat is verlopen op ${dateStr}`,
        })}
      </Alert>
    )
  }

  if (daysUntil <= 60) {
    return (
      <Alert severity="warning" sx={{ mb: 2 }}>
        {translate('resources.certificates.alerts.expiresSoon', {
          date: dateStr,
          days: daysUntil,
          _: `Certificaat verloopt op ${dateStr}`,
        })}
      </Alert>
    )
  }

  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      {translate('resources.certificates.alerts.expiresOn', {
        date: dateStr,
        _: `Certificaat verloopt op ${dateStr}`,
      })}
    </Alert>
  )
}

export default ExpiryAlert